export default __webpack_public_path__ + "static/media/BPicon.dd3a952d.svg";